module.exports = __webpack_public_path__ + "img/instagram.2ad94e2e.svg";